<template>
  <div class="">
    <Widget>
      <h3>Completed <span class="fw-semi-bold">Checkups</span></h3>
      <p>
        History for completed patient checkups
      </p>
      <div class="table-responsive">
        <table class="table table-lg mb-0 requests-table table-hover">
          <thead>
          <tr class="text-muted">
            <th width="20%"><span class="fw-bold">Date & Time</span></th>
            <th width="20%"><span class="fw-bold">Amount</span></th>
            <th width="20%"><span class="fw-bold">Doctor</span></th>
            <th width="15%"><span class="fw-bold">Action(s)</span></th>
          </tr>
          </thead>
          <tbody v-if="this.patientcheckups!==null">
          <tr v-for="patientcheckup in patientcheckups" :key="patientcheckup.id">
            <td>{{ patientcheckup.start_time }}</td>
            <td>
                <span><b>{{
                    patientcheckup.doctor.name
                  }}</b> </span>
            </td>
            <td>{{ patientcheckup.amount }}</td>
            <td>
<!--              <b-button variant="outline-success" class="fa fa-download" size="sm"  @click="downloadCheckupPrescription(patientcheckup.checkupprescription.id)">-->
<!--                Prescription-->
<!--              </b-button>-->
            </td>
          </tr>
          </tbody>
        </table>

      </div>
      <b-pagination
          v-model="currentPage"
          :total-rows="tableRows"
          :per-page="perPage"
          first-number
          align="center"
          pills
      ></b-pagination>
    </Widget>
  </div>
</template>

<script>

// import historymock from "@/pages/doctor/History/historymock";
// import AppointmentService from '@/services/doctor/appointment.service';
import UserServices from '@/services/admin/user.service'

export default {

  name: "PatientCheckupHistory",
  props: ['user_id'],
  data() {
    return {
      // historymock
      currentPage: 1,
      tableRows: 100,
      perPage: 5,
      patientcheckups: []
    };
  },
  computed: {
  },
  methods: {
    fetchCheckupHistory() {
      var id= window.location.href.split('=')[1];
      UserServices.fetchPatientCheckupHistory(id, this.currentPage)
          .then((response) => {
            if (response.status === 200) {
              this.perPage = response.data.per_page;
              this.tableRows = response.data.total;
              this.patientcheckups = response.data.data;
              // console.log("here");
              // console.log(this.patientcheckups);
            }
          })
    },
    // downloadCheckupPrescription(checkupprescription_id) {
    //   AppointmentService.fetchCheckupPrescriptionFile(checkupprescription_id)
    //       .then(response => {
    //         if (response.status === 200) {
    //           let blob = new Blob([response.data], {type: 'application/pdf'})
    //           let link = document.createElement('a')
    //           link.href = window.URL.createObjectURL(blob)
    //           link.download = 'test.pdf'
    //           link.click()
    //         }
    //       })
    //       .catch(error => {
    //         console.log(error);
    //       });
    // }
  },
  mounted() {
    this.fetchCheckupHistory();
  }
}

</script>

<style scoped>

</style>
